
import './App.css';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";

import Teacher from './Components/Teacher/Teacher';
import About from "./Components/About/About";
import React from 'react';
import Header from './Components/Header/Header';
import Contact from './Components/Contact/Contact';
import Services from "./Components/Services/Services";
import Testimonials from './Components/testimonials/Testimonials';
import Footer from './Components/Foter/Foter';
import Navbar from './Components/Navbar/Navbar';

function App() {
  
  return (
    <div  className="App">
      <>    
     <Navbar/>
        <Header />
        <About />
      <Teacher/>
        <Services />
     <Testimonials/>
        <Contact />
  <Footer/>
  
        
     

    </>
    </div>
  );
}

export default App;
